"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userCommon_en_us = void 0;
function userCommon_en_us() {
    return {
        "user.salutation": "Salutation",
        "user.salutations.male": "Mr.",
        "user.salutations.female": "Mrs."
    };
}
exports.userCommon_en_us = userCommon_en_us;
